export default __webpack_public_path__ + "static/kyungjune.kim-47181bccf92b3249b0a7380f6ad27129.jpeg";